import React, { useEffect, useRef, useState } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import qrcode from "../../../images/qr.png";
import classNames from "classnames";
import styles from "./pharmaInvoice.module.scss";
import { Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getPharmaSalesByIdSlice } from "../../../store/slices/pharmaSalesSlice";
import { useNavigate } from "react-router-dom";

const ViewPhramaInvoice = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPharmaInvoice, setShowPharmaInvoice] = useState(false);
  const pharmaInvoiceRef = useRef();
  const { clinicInfo } = useSelector((state) => state.clinic);
  const clinic = clinicInfo && clinicInfo?.length > 0 ? clinicInfo[0] : [];
  const { pharmaSalesInfo } = useSelector((state) => state.pharmaSales);
  const salesId = sessionStorage.getItem("salesId");
  const { token } = useSelector((state) => state.auth);
  useEffect(() => {
    if (salesId) {
      dispatch(getPharmaSalesByIdSlice({ id: salesId, token }));
    }
  }, [dispatch, salesId, token]);

  const downloadInvoice = async () => {
    setShowPharmaInvoice(true);
    setTimeout(async () => {
      const input = pharmaInvoiceRef.current;
      const canvas = await html2canvas(input, {
        scale: 2,
        useCORS: true,
        allowTaint: false,
        imageTimeout: 15000,
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const imgProps = pdf.getImageProperties(imgData);
      const imgWidth = pageWidth;
      const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

      let heightLeft = imgHeight;
      let position = 0;

      const imgWatermark = clinic?.hospitalInfo?.waterMark;

      // if (imgWatermark) {
      //   const pageWidth = pdf.internal.pageSize.getWidth();
      //   const pageHeight = pdf.internal.pageSize.getHeight();
      //   const watermarkWidth = pageWidth * 0.5;
      //   const watermarkHeight = pageHeight * 0.5;
      //   const x = (pageWidth - watermarkWidth) / 2;
      //   const y = (pageHeight - watermarkHeight) / 2;

      //   pdf.addImage(
      //     imgWatermark,
      //     "PNG",
      //     x,
      //     y,
      //     watermarkWidth,
      //     watermarkHeight,
      //   );
      // }

      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position -= pageHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save(
        `Pharma_invoice_${pharmaSalesInfo?.patientId?.userId?.name}.pdf`,
      );
      setShowPharmaInvoice(false);
    }, 500);
  };

  const printInvoice = async () => {
    setShowPharmaInvoice(true);
    setTimeout(async () => {
      const input = pharmaInvoiceRef.current;
      const canvas = await html2canvas(input, {
        scale: 2,
        useCORS: true,
        allowTaint: false,
        imageTimeout: 15000,
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const imgProps = pdf.getImageProperties(imgData);
      const imgWidth = pageWidth;
      const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

      let heightLeft = imgHeight;
      let position = 0;

      const imgWatermark = clinic?.hospitalInfo?.waterMark;

      // if (imgWatermark) {
      //   const pageWidth = pdf.internal.pageSize.getWidth();
      //   const pageHeight = pdf.internal.pageSize.getHeight();
      //   const watermarkWidth = pageWidth * 0.5;
      //   const watermarkHeight = pageHeight * 0.5;
      //   const x = (pageWidth - watermarkWidth) / 2;
      //   const y = (pageHeight - watermarkHeight) / 2;

      //   pdf.addImage(
      //     imgWatermark,
      //     "PNG",
      //     x,
      //     y,
      //     watermarkWidth,
      //     watermarkHeight,
      //   );
      // }

      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position -= pageHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.autoPrint();
      window.open(pdf.output("bloburl"), "_blank");
      setShowPharmaInvoice(false);
    }, 500);
  };

  const invoiceHeaderRight = () => (
    <div className={classNames("row mb-4", styles.InvoiceHeading)}>
      <div className="mt-1 col-xl-6">
        <div className="mt-1"></div>
        <small className="mt-1 ms-2">
          <strong>Name: </strong>
          {pharmaSalesInfo?.patientId?.userId?.name}
        </small>
        <small className="mt-1 ms-2">
          <strong>Email: </strong>
          {pharmaSalesInfo?.patientId?.userId?.email}
        </small>
        ,
        <small className="mt-1 ms-2">
          <strong>Phone: </strong>
          {pharmaSalesInfo?.patientId?.userId?.phone}
        </small>
      </div>
      <div className="mt-1 col-sm-6 d-flex justify-content-end">
        <div className="row">
          <div className="col-sm-9">
            <div className="brand-logo mb-3">
              {clinic?.hospitalInfo?.pdfHeader && (
                <img
                  src={clinic?.hospitalInfo?.pdfHeader}
                  className="img-fluid"
                  alt=""
                  style={{ width: "270px" }}
                  crossOrigin="anonymous"
                />
              )}
            </div>
            <span className="d-block">
              {clinic?.clinicAddress ? (
                <>
                  {clinic.clinicAddress.plot &&
                    `${clinic.clinicAddress.plot}, `}
                  {clinic.clinicAddress.area &&
                    `${clinic.clinicAddress.area}, `}
                  {clinic.clinicAddress.street &&
                    `${clinic.clinicAddress.street}, `}
                  {clinic.clinicAddress.landMark &&
                    `${clinic.clinicAddress.landMark}, `}
                  {clinic.clinicAddress.city?.name &&
                    `${clinic.clinicAddress.city.name}, `}
                  {clinic?.clinicAddress?.state?.name &&
                    `${clinic.clinicAddress.state.name}, `}
                  {clinic.clinicAddress.country?.name &&
                    `${clinic.clinicAddress.country.name}, `}
                  {clinic.clinicAddress.pin && clinic.clinicAddress.pin}
                </>
              ) : (
                "N/A"
              )}
            </span>
            <small className="d-block mt-1">
              <strong>Website</strong> : {clinic?.hospitalInfo?.web_address}
            </small>
            <small className="d-block mt-1">
              <strong>Contact No</strong> :{clinic?.phone}
            </small>
            <small className="d-block mt-1">
              <strong>GSTIN</strong> : {clinic?.accountInfo?.gst}
            </small>
          </div>
          <div className="col-sm-3 text-end">
            <img
              src={clinic?.hospitalInfo?.ISOLogo}
              className="img-fluid width110"
              alt=""
              style={{ width: "70px" }}
              crossOrigin="anonymous"
            />
          </div>
        </div>
      </div>
    </div>
  );

  const invoiceHeaderLeft = () => (
    <div className={classNames("row mb-4", styles.InvoiceHeading)}>
      <div className="mt-1 col-sm-6">
        <div className="brand-logo mb-3">
          <img
            src={clinic?.hospitalInfo?.pdfHeader}
            alt="Clinic Logo"
            crossOrigin="anonymous"
            style={{
              width: "350px",
              height: "70px",
              objectFit: "contain",
              display: "block",
            }}
          />
        </div>
        <span className="d-block">
          {clinic?.clinicAddress ? (
            <>
              {clinic.clinicAddress.plot && `${clinic.clinicAddress.plot}, `}
              {clinic.clinicAddress.area && `${clinic.clinicAddress.area}, `}
              {clinic.clinicAddress.street &&
                `${clinic.clinicAddress.street}, `}
              {clinic.clinicAddress.landMark &&
                `${clinic.clinicAddress.landMark}, `}
              {clinic.clinicAddress.city?.name &&
                `${clinic.clinicAddress.city.name}, `}
              {clinic?.clinicAddress?.state?.name &&
                `${clinic.clinicAddress.state.name}, `}
              {clinic.clinicAddress.country?.name &&
                `${clinic.clinicAddress.country.name}, `}
              {clinic.clinicAddress.pin && clinic.clinicAddress.pin}
            </>
          ) : (
            "N/A"
          )}
        </span>
        <small className="d-block mt-1">
          <strong>Website</strong> : {clinic?.hospitalInfo?.web_address}
        </small>
        <small className="d-block mt-1">
          <strong>Contact No</strong> :{clinic?.phone}
        </small>
        <small className="d-block mt-1">
          <strong>GSTIN</strong> : {clinic?.accountInfo?.gst}
        </small>
      </div>
      <div className="mt-1 col-xl-6 d-flex justify-content-end">
        <div className="row">
          <div className="col-sm-9">
            <div className="mt-1"></div>
            <small className="mt-1 ms-2">
              <strong>Name: </strong>
              {pharmaSalesInfo?.patientId?.userId?.name}
            </small>
            <small className="mt-1 ms-2">
              <strong>Email: </strong>
              {pharmaSalesInfo?.patientId?.userId?.email}
            </small>
            ,
            <small className="mt-1 ms-2">
              <strong>Phone: </strong>
              {pharmaSalesInfo?.patientId?.userId?.phone}
            </small>
          </div>
          <div className="col-sm-3 text-end">
            {clinic?.hospitalInfo?.displayISOlogo && (
              <img
                src={clinic?.hospitalInfo?.ISOLogo}
                alt="ISO Logo"
                crossOrigin="anonymous"
                style={{
                  width: "52px",
                  height: "60px",
                  objectFit: "contain",
                  display: "block",
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );

  const invoiceHeaderCenter = () => (
    <div className={classNames("row mb-4", styles.InvoiceHeading)}>
      <div className="mt-1 col-sm-9 d-flex justify-content-between">
        <div className="brand-logo mb-3">
          <img
            className="logo-abbr me-2"
            src={clinic?.hospitalInfo?.pdfHeader}
            alt=""
            crossOrigin="anonymous"
          />
        </div>
      </div>
      <div className="mt-1 col-sm-3 text-end">
        {clinic?.hospitalInfo?.displayISOlogo && (
          <img
            src={clinic.hospitalInfo.ISOLogo}
            className="img-fluid width110"
            alt=""
            style={{ width: "70px" }}
            crossOrigin="anonymous"
          />
        )}
      </div>
      <div className="mt-1 col-sm-12">
        <span className="d-block">
          {clinic?.clinicAddress ? (
            <>
              {clinic.clinicAddress.plot && `${clinic.clinicAddress.plot}, `}
              {clinic.clinicAddress.area && `${clinic.clinicAddress.area}, `}
              {clinic.clinicAddress.street &&
                `${clinic.clinicAddress.street}, `}
              {clinic.clinicAddress.landMark &&
                `${clinic.clinicAddress.landMark}, `}
              {clinic.clinicAddress.city?.name &&
                `${clinic.clinicAddress.city.name}, `}
              {clinic?.clinicAddress?.state?.name &&
                `${clinic.clinicAddress.state.name}, `}
              {clinic.clinicAddress.country?.name &&
                `${clinic.clinicAddress.country.name}, `}
              {clinic.clinicAddress.pin && clinic.clinicAddress.pin}
            </>
          ) : (
            "N/A"
          )}
        </span>
        <small className="d-block mt-1">
          <strong>Website</strong> : {clinic?.hospitalInfo?.web_address}
        </small>
        <small className="d-block mt-1">
          <strong>Contact No</strong> :{clinic?.phone}
        </small>
        <small className="d-block mt-1">
          <strong>GSTIN</strong> : {clinic?.accountInfo?.gst}
        </small>
      </div>
      <div className=" col-sm-12 mt-3 mb-3">
        <div style={{ backgroundColor: "#40be47", padding: "1px" }}></div>
      </div>
      <div className="mt-1 col-xl-12">
        <small className="mt-1 ms-2">
          <strong>Name: </strong>
          {pharmaSalesInfo?.patientId?.userId?.name}
        </small>
        <small className="mt-1 ms-2">
          <strong>Email: </strong>
          {pharmaSalesInfo?.patientId?.userId?.email}
        </small>
        ,
        <small className="mt-1 ms-2">
          <strong>Phone: </strong>
          {pharmaSalesInfo?.patientId?.userId?.phone}
        </small>
      </div>
    </div>
  );

  const invoiceHeaderFullWidth = () => (
    <div className={classNames("row mb-4", styles.InvoiceHeading)}>
      <div className="mt-1 col-sm-5">
        <div className="brand-logo mb-3">
          <img
            className="logo-abbr me-2"
            src={clinic?.hospitalInfo?.pdfHeader}
            alt=""
            crossOrigin="anonymous"
          />
        </div>
      </div>
      <div className="mt-1 col-sm-5">
        <span className="d-block">
          {clinic?.clinicAddress ? (
            <>
              {clinic.clinicAddress.plot && `${clinic.clinicAddress.plot}, `}
              {clinic.clinicAddress.area && `${clinic.clinicAddress.area}, `}
              {clinic.clinicAddress.street &&
                `${clinic.clinicAddress.street}, `}
              {clinic.clinicAddress.landMark &&
                `${clinic.clinicAddress.landMark}, `}
              {clinic.clinicAddress.city?.name &&
                `${clinic.clinicAddress.city.name}, `}
              {clinic?.clinicAddress?.state?.name &&
                `${clinic.clinicAddress.state.name}, `}
              {clinic.clinicAddress.country?.name &&
                `${clinic.clinicAddress.country.name}, `}
              {clinic.clinicAddress.pin && clinic.clinicAddress.pin}
            </>
          ) : (
            "N/A"
          )}
        </span>
        <small className="d-block mt-1">
          <strong>Website</strong> : {clinic?.hospitalInfo?.web_address}
        </small>
        <small className="d-block mt-1">
          <strong>Contact No</strong> :{clinic?.phone}
        </small>
        <small className="d-block mt-1">
          <strong>GSTIN</strong> : {clinic?.accountInfo?.gst}
        </small>
      </div>
      <div className="mt-1 col-sm-2 text-end">
        {clinic?.hospitalInfo?.displayISOlogo && (
          <img
            src={clinic?.hospitalInfo?.ISOLogo}
            className="img-fluid width110"
            alt=""
            style={{ width: "70px" }}
            crossOrigin="anonymous"
          />
        )}
      </div>

      <div className=" col-sm-12 mt-3 mb-3">
        <div style={{ backgroundColor: "#40be47", padding: "1px" }}></div>
      </div>
      <div className="mt-1 col-xl-12">
        <small className="mt-1 ms-2">
          <strong>Name: </strong>
          {pharmaSalesInfo?.patientId?.userId?.name}
        </small>
        <small className="mt-1 ms-2">
          <strong>Email: </strong>
          {pharmaSalesInfo?.patientId?.userId?.email}
        </small>
        ,
        <small className="mt-1 ms-2">
          <strong>Phone: </strong>
          {pharmaSalesInfo?.patientId?.userId?.phone}
        </small>
      </div>
    </div>
  );

return (
  <div>
    {/* Header */}
    <div className="d-flex justify-content-between align-items-center mb-3">
      <h4 className="m-0">Pharma Invoice</h4>
      <button
        className="btn btn-primary"
        onClick={() => navigate("/pharmaSales")}
      >
        Back to List
      </button>
    </div>

    {/* Invoice Wrapper */}
    <Row
      className={
        showPharmaInvoice ? styles.InvoiceWrapper : styles.InvoiceWrapperTwo
      }
    >
      <div className="col-lg-12">
        <div
          className={classNames(styles.InvoiceCard, "card")}
          ref={pharmaInvoiceRef}
          style={{ position: "relative" }}
        >
          {/* Watermark */}
          {clinic?.hospitalInfo?.waterMark && (
            <img
              src={clinic.hospitalInfo.waterMark}
              crossOrigin="anonymous"
              alt="watermark"
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                opacity: 0.08,
                width: "60%",
                zIndex: 0,
                pointerEvents: "none",
              }}
            />
          )}

          {/* Invoice content */}
          <div
            className="card-body mb-auto position-relative"
            style={{ minHeight: "200vh", zIndex: 1 }}
          >
            {/* Invoice Header */}
            {clinic?.hospitalInfo?.headerAlignment === "right" &&
              invoiceHeaderRight()}
            {clinic?.hospitalInfo?.headerAlignment === "left" &&
              invoiceHeaderLeft()}
            {clinic?.hospitalInfo?.headerAlignment === "center" &&
              invoiceHeaderCenter()}
            {clinic?.hospitalInfo?.headerAlignment === "headerFullWidth" &&
              invoiceHeaderFullWidth()}

            {/* Invoice Table */}
            <div className="table-responsive">
              <table className="table">
                <thead className={styles.thead}>
                  <tr className={styles.tr}>
                    <th className={classNames(styles.th, "center")}>Sl No</th>
                    <th className={classNames(styles.th, "center")}>
                      Item Name
                    </th>
                    <th className={classNames(styles.th, "center")}>
                      HSN Code
                    </th>
                    <th className={classNames(styles.th, "center")}>
                      Batch No
                    </th>
                    <th className={classNames(styles.th, "center")}>
                      Expiry Date
                    </th>
                    <th className={classNames(styles.th, "center")}>Rate</th>
                    <th className={classNames(styles.th, "center")}>Qty</th>
                    <th className={classNames(styles.th, "center")}>Tax/GST</th>
                    <th className={classNames(styles.th, "right")}>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {pharmaSalesInfo?.item?.length > 0 &&
                    pharmaSalesInfo.item.map((data, index) => (
                      <tr key={`item-${data?._id}`}>
                        <td className="center">{index + 1}</td>
                        <td className="left">{data?.stockId?.name || "N/A"}</td>
                        <td className="right">{data?.stockId?.hsnCode}</td>
                        <td className="right">{data?.stockId?.batchNumber}</td>
                        <td>
                          {data?.expiryDate &&
                            new Date(data?.expiryDate).toLocaleDateString(
                              "en-IN",
                              { month: "2-digit", year: "2-digit" }
                            )}
                        </td>
                        <td className="right">{data?.rate.toFixed(2)}</td>
                        <td className="center">{data?.quantity}</td>
                        <td className="center">
                          {data?.matchedPurchase?.item?.taxRate}%
                        </td>
                        <td className="right">{data?.total.toFixed(2)}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>

            {/* Subtotal & Payment Info */}
            <div className="row">
              <div className="col-sm-4"></div>
              <div className="col-sm-4 ms-auto">
                <table
                  className={classNames(styles.subTotalTable, "table table-clear")}
                >
                  <tbody>
                    <tr>
                      <td className={classNames(styles.td, "left")}>
                        <strong>Amount</strong>
                      </td>
                      <td className={classNames(styles.td, "right")}>
                        <strong>{pharmaSalesInfo?.subTotal}</strong>
                      </td>
                    </tr>
                    <tr>
                      <td className={classNames(styles.td, "left")}>
                        <strong>Discount</strong>
                      </td>
                      <td className={classNames(styles.td, "right")}>
                        <strong>{pharmaSalesInfo?.discount}</strong>
                      </td>
                    </tr>
                    <tr>
                      <td className={classNames(styles.td, "left")}>
                        <strong>Paid Amount</strong>
                      </td>
                      <td className={classNames(styles.td, "right")}>
                        <strong>{pharmaSalesInfo?.paidAmount}</strong>
                      </td>
                    </tr>
                    <tr>
                      <td className={classNames(styles.td, "right")}>
                        <strong
                          className={`${
                            pharmaSalesInfo?.paymentStatus === "PAID"
                              ? "text-success"
                              : "text-danger"
                          }`}
                          style={{ fontSize: "2rem" }}
                        >
                          {pharmaSalesInfo?.paymentStatus}
                        </strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            {/* Footer: Signature & QR */}
            <div style={{ position: "absolute", bottom: 0, width: "100%" }}>
              <div className="pb-2 ps-5 pe-0 d-flex justify-content-between position-relative">
                <div>
                  <b
                    style={{
                      fontSize: "0.9rem",
                      position: "absolute",
                      bottom: "0.6rem",
                    }}
                  >
                    Billed By : SimpleeKare
                  </b>
                </div>
                <div style={{ paddingRight: 35, marginTop: 10 }}>
                  <div className="d-flex flex-column align-items-center justify-content-center">
                    <img
                      src={clinic?.hospitalInfo?.authorizedSignature}
                      alt="Authorized Signature"
                      crossOrigin="anonymous"
                      style={{
                        width: "150px",
                        height: "70px",
                        objectFit: "contain",
                        display: "block",
                      }}
                    />
                    <b style={{ fontSize: "0.95rem" }}>Signature</b>
                  </div>
                </div>
              </div>

              <div className="row pb-4 ps-5 pe-5">
                <div style={{ backgroundColor: "#40be47", padding: "1px" }}></div>
                <div className="col-sm-12 p-0 mt-4">
                  <div className="brand-logo d-flex align-items-center justify-content-between">
                    <img
                      className="logo-abbr me-2"
                      src={qrcode}
                      alt=""
                      style={{ width: "80px" }}
                      crossOrigin="anonymous"
                    />
                    <b style={{ fontSize: "0.85rem" }}>
                      * No Extra Amount to be paid apart from Billing Amount.
                    </b>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Row>

    {/* Download / Print Buttons */}
    <div className="mt-3">
      <button
        className="btn btn-primary me-2 text-white"
        onClick={downloadInvoice}
      >
        Download PDF
      </button>
      <button
        className="btn btn-success text-white"
        onClick={printInvoice}
      >
        Print Invoice
      </button>
    </div>
  </div>
);
};

export default ViewPhramaInvoice;
